import { render, staticRenderFns } from "./JdCategoryTabs.vue?vue&type=template&id=45348bf1&scoped=true&"
import script from "./JdCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./JdCategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./JdCategoryTabs.vue?vue&type=style&index=0&id=45348bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45348bf1",
  null
  
)

export default component.exports